import { NavLink, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { confirmAlert } from 'react-confirm-alert';
import { HiOutlineBell } from 'react-icons/hi';

export default function CustomerHead({
  back,
  title,
  desc
}) {

  const navigate = useNavigate();

  const logOut = () => {
    confirmAlert({
      title: 'Do you want to log out?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');

            document.location.href = '/login';
          }
        },
        {
          label: 'No'
        }
      ]
    });
  };
  return (
    <CustomerHeader>
      <div className='inner'>
        <div className='tit-con'>
          {back ? (
            <button
              className='tit-ic back-btn'
              onClick={() => navigate(-1)} // 클릭 시 뒤로가기 기능 추가
            />
          ) : (
            <div className='tit-ic'>
              <span>P</span>
            </div>
          )}

          <div className='tit-desc'>
            <h4>{title}</h4>
            <span>{desc}</span>
          </div>
        </div>
        <div className='util-menu'>
          {/*<NavLink to='/customer/notice' className='alarm-btn'>*/}
          {/*  <HiOutlineBell/>*/}
          {/*</NavLink>*/}
          <button
            className='logout-btn'
            onClick={logOut}
          >Logout
          </button>
        </div>
      </div>
    </CustomerHeader>
  );
}

const CustomerHeader = styled.header`
  z-index: 99;
  position: sticky;
  top: 0;
  background: #fff;
  border-bottom: 1px solid #E5E7EB;
  padding: 15px 20px;

  .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;

    .tit-con {
      position: relative;
      display: flex;
      align-items: center;
      gap: 12px;

      .tit-ic {
        width: 30px;
        height: 30px;
        border-radius: 10px;
        background: #0072B9;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-size: 14px;
          font-weight: 700;
          color: #fff;
        }

        &.back-btn {
          background:#0072B9 url('https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/main/drop_arrow_w.svg') top 50% left 50% no-repeat;
          background-size:30px 30px;
          transform:rotate(90deg);
        }
      }


      .tit-desc {
        h4 {
          font-size: 18px;
          font-weight: 700;
          color: #111827;
        }

        span {
          font-size: 12px;
          font-weight: 400;
          color: #6b7280;
        }
      }
    }

    .util-menu {
      display: flex;
      align-items: center;
      gap: 0 15px;

      .alarm-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
      }

      .logout-btn {
        padding: 0 10px;
        height: 35px;
        line-height: 40px;
        border-radius: 5px;
        background: #0072B9;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
`;
